
import { createModel } from '@rematch/core'

const initialState: { showToast:  boolean, message: any  } = {
   
    showToast: false, 
    message: ""

}


export const toastModel = createModel()({
    state: { ...initialState },
    reducers: {

        setShowToast(state, payload) {
            return {
                ...state,
                showToast: payload.showToast,
                message: payload.message
            }
        },

        setShowMessage(state, payload) {
            return {
                ...state,
                message: payload,
            }
        },
      
    },
   

})